<template>
  <div style="padding-right:20px">
      <button @click="logout()" class="btn btn-danger">Logout</button>
  </div>               
</template>
<script>
  export default {
    name: 'header-dropdown',
    data: () => {
      return { itemsCount: 0 }
    },
    
    methods : {
      logout ()
      {
        localStorage.clear()
        this.$router.push("/login")
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Header/HeaderDropdown.vue